import React from "react";
import "~/css/ExpandPanel.css";

type ExpandItem = {
  key: string;
  icon: string;
  label?: string;
  onClick: () => void;
};

interface ExpandPanelProps {
  isOpen: boolean;
  onClose: () => void;
  items: ExpandItem[];
}

const ExpandPanel: React.FC<ExpandPanelProps> = ({ isOpen, onClose, items }) => {
  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <div className={`expand-panel${isOpen ? " open" : ""}`} onClick={(e) => e.stopPropagation()}>
        <div className="expand-panel-content">
          {/* 先頭に閉じるアイコン */}
          <button
            className="expand-item expand-close-item"
            aria-label="close expand menu"
            onClick={onClose}
          >
            <span className="material-symbols-rounded">right_panel_close</span>
          </button>
          {items.map(({ key, icon, label, onClick }) => (
            <button key={key} className="expand-item" onClick={onClick}>
              <span className="material-symbols-rounded">{icon}</span>
              {label && <span className="label">{label}</span>}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default ExpandPanel;
